"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../../common/components/Text/Text"));

var _Icon = _interopRequireDefault(require("../../common/components/Icon/Icon"));

var _lodash = require("lodash");

var _constants = require("../../common/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SLDViewer(props) {
  var renderComponent = function renderComponent(asset) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _defineProperty({}, _constants.core.SLD_ICON_TYPES.LABEL, /*#__PURE__*/_react.default.createElement(_Text.default, {
      key: "sldLabel-".concat(asset.txtId),
      asset: asset,
      sizeOfElements: _constants.core.sizeOfElements
    }))[asset.className] || /*#__PURE__*/_react.default.createElement(_Icon.default, {
      key: "sldImage-".concat(asset.txtId),
      asset: asset,
      sizeOfElements: _constants.core.sizeOfElements,
      isNoParamsSelectedTitleShow: props.isNoParamsSelectedTitleShow,
      onRightClick: props.onRightClick
    }));
  };

  var filterData = (0, _lodash.filter)(props.data, function (asset) {
    return asset !== 0 && asset.isPalletteElement !== 'false';
  });
  if (filterData.length === 0) return /*#__PURE__*/_react.default.createElement("h1", null, "No Data Returned to specified SLD");
  return (0, _lodash.map)(filterData, function (asset) {
    return renderComponent(asset);
  });
}

var _default = SLDViewer;
exports.default = _default;